import React, { useState } from "react";

const LoginMain = ({ handleLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(email, password); // Call the onLogin function passed as a prop
  };

  return (
    <div className="react-login-page react-signup-page pt---120 pb---120">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="login-right-form">
              <form onSubmit={handleSubmit}>
                <div className="login-top">
                  <h3>Login</h3>
                </div>
                <p>
                  <label>Username</label>
                  <input
                    type="name"
                    id="email"
                    name="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </p>
                <p>
                  <label>Password</label>
                  <input
                    type="password"
                    id="pass"
                    name="pass"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                  />
                </p>
                <button type="submit" id="button" name="submit">
                  LogIn
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginMain;
